











































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Prop,
    Vue,
    Watch
} from 'vue-property-decorator';
import {
    HOST
} from "../global";
import {
    API_URL
} from "../global";
import {
    pageDataType,
    componentDataType,
    settinglinkItem
} from "../types";

import {
    SET_GLOBAL_ERROR,
    SET_GLOBAL,
    SET_GLOBAL_LOADED,
    SET_SETTING_DATA
} from "../store/mutations.names";
import {
    FETCH_GLOBAL,
    FETCH_SETTING_DATA,
    FETCH_SETTING

} from "../store/actions.names";

import axios from 'axios';
import {
    TimelineMax,
    TweenLite,
    Power1,
    TweenMax,
    Expo,
    Power2,
    Power3,
    Power4
} from "gsap";
import ScrollMagic from "scrollmagic";
import gsap from 'scrollmagic';
@Component({
    name: "IndustryMap",
})
export default class IndustryMap extends Vue {
    @Prop() readonly compData!: any;
    public HOST: string = HOST;
    @Getter("settinglink") public settinglink!: settinglinkItem[];
    @Action(FETCH_SETTING) public[FETCH_SETTING]: any;
   
    startLocation: any = {
        lat: 23.861106,
        lng: 90.399058
    }
    getPosition(marker: any) {
        return {
            lat: parseFloat(marker.lat),
            lng: parseFloat(marker.lng)
        }
    }
    public mapAnim() {
        const cont = new ScrollMagic.Controller();
        const tl = new TimelineMax()
            .to('.mapwrap', .01, {
                overflow: 'hidden'
            }, 0.02)
            .staggerFrom('.globalmap-wrapper', .8, {
                xPercent: -40,
                autoAlpha: 0,
                width: '20%',
                ease: Power2.easeIn,
                // clearProps: 'all'
            }, 0.2)
            .to('.mapwrap', .01, {
                clearProps: 'all'
            }, 0.02)

        const text = new ScrollMagic.Scene({
                triggerElement: '.mapwrap',
                // offset: 20,
                reverse: false
            })
            .setTween(tl)
            .addTo(cont);

        // back

        const textline = new ScrollMagic.Controller();
        const tml = new TimelineMax()

            .staggerFrom('.maptext-block', .8, {
                yPercent: 40,
                // height: '50%',
                autoAlpha: 0,
                ease: Power2.easeOut,
                // clearProps: 'all'
            }, 0.02)
            .staggerFrom('.maptext-block h2', .5, {
                yPercent: 30,
                autoAlpha: 0,
                ease: Power4.easeOut,
                // clearProps: 'all'
            }, 0.02, '-=.3')
            .staggerFrom('.maptext-block .maprichtext', .5, {
                yPercent: 30,
                autoAlpha: 0,
                ease: Power4.easeOut,
                // clearProps: 'all'
            }, 0.02, '-=.3')
        const timeline = new ScrollMagic.Scene({
                triggerElement: '.maptext-block',
                // offset: 20,
                reverse: false
            })
            .setTween(tml)
            .addTo(textline);
    }
    public mounted() {

        if (window.matchMedia("(min-width: 1025px)").matches) {
            this.mapAnim();
        }

    }
}
